<template>
  <div class="fullscreen">
    <!-- <h1 class="text-h1">DeepPathology</h1>
    <router-link :to="{ name: 'project-list' }">Sign in</router-link> -->
    <v-img
      src="@/assets/welcome_image_thin.jpg"
      gradient="to bottom, rgba(100,115,201,0), rgba(255,255,255,.7)"
      class="fullheight-image"
    >
        <v-alert type="info" v-if="showBrowserWarning"
          >{{ $t("home.browserWarning") }}</v-alert
        >
        <v-alert type="info" v-if="showScreenResolutionWarning"
          >{{ $t("home.screenResolutionWarning") }}</v-alert
        >
        <div
          class="d-flex text-h2 mr-16 justify-end fullheight"
        >
          <v-col class="f-flex align-self-center">
            <v-row class="justify-end">
              <span class="d-flex align-self-center text-block text-end">{{$t("home.welcomeMessage").replace(" ", "\n")}}</span>
            </v-row>
            <v-row class="justify-end">
              <span class="subtitle-1 grey--text d-flex align-self-center">{{$t("home.welcomeSubtitle")}}</span>
            </v-row>
            <v-row class="justify-end" v-if="!keycloak.authenticated">
              <v-col
                cols="auto"
              >
                <Locale-changer/>
              </v-col>
              <!-- <v-list-item class="">
                <v-list-item-icon>
                  <v-icon>mdi-web</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <Locale-changer/>
                </v-list-item-content>
              </v-list-item> -->
            </v-row>
          </v-col>
        </div>
    </v-img>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LocaleChanger from "@/components/LocaleChanger";
export default {
  data() {
    return {
      showBrowserWarning: false,
      showScreenResolutionWarning: false,
    }
  },
  computed: {
    ...mapState({
      keycloak: state => state.authentication.keycloak
    }),
  },
  mounted() {
    // Check browser
    const isOpera = (navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR'))!= -1;
    const isChrome = navigator.userAgent.indexOf("Chrome") != -1;
    const isEdge = navigator.userAgent.indexOf("Edge") > -1;
    // Check Screen Size
    const isHeight = window.innerHeight > 882;
    const isWidth = window.innerWidth > 1440;
    this.showBrowserWarning = !isChrome && !isOpera && !isEdge;
    this.showScreenResolutionWarning = !isHeight || !isWidth;
  },
  components: {
    LocaleChanger
  }
};
</script>

<style scoped>
.fullheight {
  height: 100%;
}
.fullheight-image {
  height: calc(100vh - 64px) !important;
}
.text-block {
  white-space: pre;
}
>>>#input-16 {
  max-width: 20px !important;
}
</style>
